import { StoreState } from '@/core/models/store.interface';
import i18n from '@/i18n';
import { Module } from 'vuex';
import { AvailabilityTodo, MediumTypeKey } from './availability-todo.interface';
import availabilityTodoService from './availability-todo.service';

export interface AvailabilityTodoState {}

const AvailabilityTodoStore: Module<AvailabilityTodoState, StoreState> = {
   namespaced: true,
   state: {},

   getters: {},

   mutations: {},

   actions: {
      async post(
         context,
         {
            pool_id,
            board_id,
            medium_type_key,
            assigned_candidate_ids,
            start_date,
            end_date,
         }: {
            pool_id: number;
            board_id: number;
            medium_type_key: MediumTypeKey;
            assigned_candidate_ids: number[];
            start_date: string;
            end_date: string;
         },
      ) {
         const BODY = { medium_type_key, assigned_candidate_ids, start_date, end_date } as AvailabilityTodo;
         if (pool_id) BODY['pool_id'] = pool_id;
         if (board_id) BODY['board_id'] = board_id;

         return await availabilityTodoService.post(BODY).then(() => {
            context.dispatch(
               'addNotification',
               {
                  notification: {
                     type: 'success',
                     message: `${i18n.global.t('pool.the_availabilites_have_been_requested')}`,
                  },
               },
               { root: true },
            );
         });
      },
   },
};

export default AvailabilityTodoStore;
